module.exports = __webpack_public_path__ + "img/icon.d95a15e5.svg";